import { Image as KonvaImage, Transformer } from 'react-konva';
import useImage from 'use-image';
import React, { useEffect, useRef } from 'react';

const DraggableComponent = ({ 
  shape, 
  isSelected, 
  onSelect, 
  onErase, 
  stageRef, 
  tool, 
  setShapes,
  pushHistory
}) => {
  const [img] = useImage(shape.image);
  const shapeRef = useRef();
  const transformerRef = useRef();
  const isTransforming = useRef(false);

  useEffect(() => {
    if (isSelected && transformerRef.current && shapeRef.current) {
      transformerRef.current.nodes([shapeRef.current]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const handleClick = (e) => {
    e.cancelBubble = true;
    if (tool === 'eraser') {
      onErase();
    } else {
      onSelect();
    }
  };

  const handleDragEnd = (e) => {
    const node = e.target;
    const newPos = node.position();
    
    setShapes(prev => {
      const updatedShapes = prev.map(s => {
        if (s.id !== shape.id) return s;
        return {
          ...s,
          x: newPos.x,
          y: newPos.y
        };
      });
      pushHistory(updatedShapes);
      return updatedShapes;
    });
  };

  const handleTransformEnd = (e) => {
    const node = e.target;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    const rotation = node.rotation ? node.rotation() : 0;
    
    // Reset scale to avoid compounding
    node.scaleX(1);
    node.scaleY(1);
    
    setShapes(prev => {
      const updatedShapes = prev.map(s => {
        if (s.id !== shape.id) return s;
        
        return {
          ...s,
          x: node.x(),
          y: node.y(),
          width: Math.max(10, s.width * scaleX),
          height: Math.max(10, s.height * scaleY),
          rotation: rotation
        };
      });
      pushHistory(updatedShapes);
      return updatedShapes;
    });
  };

  return (
    <>
      <KonvaImage
        key={shape.id}
        id={shape.id}
        image={img}
        ref={shapeRef}
        x={shape.x}
        y={shape.y}
        width={shape.width}
        height={shape.height}
        rotation={shape.rotation || 0}
        draggable={tool === 'select' && isSelected}
        onClick={handleClick}
        onTap={handleClick}
        onDragEnd={handleDragEnd}
        onTransformEnd={handleTransformEnd}
      />
      {tool === 'select' && isSelected && (
        <Transformer
          ref={transformerRef}
          rotateEnabled={true}
          anchorSize={8}
          boundBoxFunc={(oldBox, newBox) => newBox}
        />
      )}
    </>
  );
};

export default DraggableComponent;
